import {
  GET_USER_PROFILE,
  USER_PROFILE_SUCCESS,
  USER_ENTITIES,
  USER_ENTITIES_SAVE,
  USER_MODULES,
  USER_MODULES_SAVE,
  USER_DATE_SAVE,
  SESSION_TIMEOUT,
} from '../types/actionTypes';

const INIT_STATE = {
  userinfo: {},
  entities: [],
  modules: [],
  date: {
    timeStart: null,
    timeEnd: null,
    dateStart: new Date(),
    dateEnd: new Date(),
  },
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case GET_USER_PROFILE:
      return { ...state };
    case USER_PROFILE_SUCCESS:
      return { ...state, userinfo: payload };
    case USER_ENTITIES_SAVE:
      return { ...state, entities: payload };
    case USER_ENTITIES:
      return { ...state, entities: payload };
    case USER_MODULES:
      return { ...state, modules: payload };
    case USER_MODULES_SAVE:
      return { ...state, modules: payload };
    case USER_DATE_SAVE:
      return { ...state, date: payload.date };
    case SESSION_TIMEOUT:
      let userinfo_ = state.userinfo;
      if (state.userinfo.userinfo.username){
        userinfo_.userinfo.username = "TIMEOUT";
      }
      return { ...state, userinfo: userinfo_ };
    default:
      return { ...state };
  }
};
